<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{ error }}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Neue Abrechnung</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>
                        Füllen Sie bitte alle Felder aus, um einen neuen Kunden
                        hinzuzufügen.
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="3">
                      <v-card>
                        <v-card-text>
                          <div>
                            Start Datum:
                            {{ invoice.startDate | moment("DD.MM.YYYY") }}
                          </div>
                          <div>
                            End Datum:
                            {{ invoice.endDate | moment("DD.MM.YYYY") }}
                          </div>
                          <div>
                            <h2>
                              Betrag: {{ (invoice.total / 100).toFixed(2) }} €
                            </h2>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="selectedMonth"
                        :items="months"
                        label="Abrechnungsmonat"/>

                        <v-select
                          v-model="selectedCountry"
                          label="Lieferland"
                          multiple
                          :items="getCountries()"
                          @change="countryChanged()"></v-select>
                    </v-col>

                    <v-col offset="6" v-if="selectedOrders.length > 0">
                      <v-btn class="primary" @click="save">
                        <v-icon>mdi-content-save</v-icon>Rechnung erzeugen
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn 
                        class="mb-2"
                        color="primary"
                        @click="toggleSelectAll"
                      >
                        {{ isAllSelected ? 'Alle abwählen' : 'Alle auswählen' }}
                      </v-btn>

                      <v-text-field
                        v-model="searchTerm"
                        placeholder="Suche"
                      >
                      </v-text-field>
                      
                      <v-data-table
                        :v-if="orders"
                        :headers="orderHeaders"
                        :items="filterOrders()"
                        :sort-by="['status']"
                        :search="searchTerm"
                        class="elevation-1"
                        v-model="selectedOrders"
                        :items-per-page="500"
                        item-key="id"
                        show-select
                      >
                        <template v-slot:item.date="{ item }">
                          <span>{{
                            item.date | moment("DD.MM.YYYY HH:mm")
                          }}</span>
                        </template>
                        <template v-slot:item.updated="{ item }">
                          <span>{{
                            item.updated | moment("DD.MM.YYYY HH:mm")
                          }}</span>
                        </template>

                        <template v-slot:item.total="{ item }">
                          <span
                            >{{
                              (
                                (item.engravingPrice + item.shippingPrice) /
                                100
                              ).toFixed(2)
                            }}
                            €</span
                          >
                        </template>

                        <template v-slot:item.engravingPrice="{ item }">
                          <span
                            >{{
                              (
                                item.engravingPrice /
                                100
                              ).toFixed(2)
                            }}
                            €</span
                          >
                        </template>

                        <template v-slot:item.shippingPrice="{ item }">
                          <span
                            >{{
                              (
                                item.shippingPrice /
                                100
                              ).toFixed(2)
                            }}
                            €</span
                          >
                        </template>
                        <template v-slot:item.cartonPrice="{ item }">
                          <span
                            >{{
                              
                              item.cartonPrice ? (
                                item.cartonPrice /
                                100
                              ).toFixed(2) : 0
                            }}
                            €</span
                          >
                        </template>

                        <template v-slot:item.status="{ item }">
                          <v-chip v-if="item.status == 'pending'">{{
                            item.status
                          }}</v-chip>
                          <v-chip
                            color="green"
                            v-if="item.status == 'shipped'"
                            >{{ item.status }}</v-chip
                          >
                          <v-chip color="red" v-if="item.status == 'cancled'">{{
                            item.status
                          }}</v-chip>
                          <v-chip v-if="item.status == 'waiting'">{{
                            item.status
                          }}</v-chip>
                        </template>

                        <template v-slot:item.label="{ item }">
                          <v-chip color="green" v-if="item.label == 1">Ja</v-chip>
                          
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import CustomersSerivce from "@/services/CustomerService";

export default {
  name: "dashboard",
  components: {
    Header: Header,
  },
  data: () => ({
    loading: true,
    error: null,
    orders: [],
    searchTerm: null,
    selectedOrders: [],
    invoice: {
      startDate: null,
      endDate: null,
      total: 0,
      state: "unpaid",
      orderIds: [],
    },
    orderHeaders: [
      { text: "ID", value: "id" },
      { text: "PlentyId", value: "plentyId" },
      { text: "Datum", value: "date" },
      { text: "Referenz", value: "reference" },
      { text: "Land", value: "country" },
      { text: "Produktpreis", value: "engravingPrice" },
      { text: "Versandkosten", value: "shippingPrice" },
      { text: "Kartonage", value: "cartonPrice" },
      { text: "Gesamt", value: "total" },
      { text: "Eigenes Label", value: "label" },
      { text: "Letzte Änderung", value: "updated" },
      { text: "Status", value: "status", sortable: true },
    ],
    selectedMonth: null,
    months: [
      {
        text: "Januar",
        value: 1,
      },
      {
        text: "Februar",
        value: 2,
      },
      {
        text: "März",
        value: 3,
      },
      {
        text: "April",
        value: 4,
      },
      {
        text: "Mai",
        value: 5,
      },
      {
        text: "Juni",
        value: 6,
      },
      {
        text: "Juli",
        value: 7,
      },
      {
        text: "August",
        value: 8,
      },
      {
        text: "September",
        value: 9,
      },
      {
        text: "Oktober",
        value: 10,
      },
      {
        text: "November",
        value: 11,
      },
      {
        text: "Dezember",
        value: 12,
      }
    ],
    isAllSelected: false,
  }),
  mounted() {
    this.refresh();
  },
  watch: {
    selectedOrders: {
      deep: true,
      handler() {
        this.generateInvoiceData();
      },
    },
    selectedMonth() {
      this.isAllSelected = false;
    },
    selectedCountry() {
      this.isAllSelected = false;
    },
    searchTerm() {
      this.isAllSelected = false;
    }
  },
  methods: {
    countryChanged() {
      let orders  = [...this.orders];
      this.orders = [];
      this.$nextTick(() => {
        this.orders = orders;
      });
    },
    filterOrders() {
      let orders = this.orders;

      if (this.selectedMonth != null && this.selectedMonth !== 0) {
        orders = orders.filter((o) => {
          let date = new Date(o.date);
          return date.getMonth() + 1 === this.selectedMonth;
        });
      }

      if (this.selectedCountry != null && this.selectedCountry.length > 0) {
        orders = orders.filter((o) => {
          return this.selectedCountry.includes(o.country);
        });
      }

      if (this.searchTerm) {
        const searchLower = this.searchTerm.toLowerCase();
        orders = orders.filter(item => 
          Object.values(item).some(val => 
            String(val).toLowerCase().includes(searchLower)
          )
        );
      }

      return orders;
    },

    getCountries() {
      let countries = [];
      if(!this.orders) return countries;

      for (let o of this.orders) {
        if (!countries.includes(o.country)) {
          countries.push(o.country);
        }
      }
      return countries;
    },

    generateInvoiceData() {
      if (this.selectedOrders.length === 0) {
        this.invoice.startDate = null;
        this.invoice.endDate = null;
        this.invoice.total = 0;
        return;
      }

      const chunkSize = 1000;
      let total = 0;
      
      for (let i = 0; i < this.selectedOrders.length; i += chunkSize) {
        const chunk = this.selectedOrders.slice(i, i + chunkSize);
        chunk.forEach(order => {
          total += order.engravingPrice + 
                  order.shippingPrice + 
                  (order.cartonPrice || 0);
        });
      }

      const dates = this.selectedOrders.map(order => new Date(order.date));
      this.invoice.startDate = new Date(Math.min(...dates));
      this.invoice.endDate = new Date(Math.max(...dates));
      this.invoice.total = total;
    },

    async save() {
      this.loading = true;
      this.invoice.orders = this.selectedOrders;
      try {
        let payload = this.invoice;

        //name == Month + Country
        let monthName = this.months.find((m) => m.value == this.selectedMonth);
        payload.name = monthName.text + " " + this.selectedCountry.join(", ");

        await CustomersSerivce.createInvoice(
          this.$route.params.appId,
          this.$route.params.customerId,
          payload
        );
      } catch (err) {
        alert(err.message);
      } finally {
        router.back();
      }
    },

    async refresh() {
      try {
        this.loading = true;

        try {
          this.orders = (
            await CustomersSerivce.getUnpaidOrders(
              this.$route.params.customerId
            )
          ).data;
        } catch (err) {
          alert(err.message);
          router.back();
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedOrders = [];
      } else {
        this.selectedOrders = this.filterOrders();
      }
      this.isAllSelected = !this.isAllSelected;
    },
  },
};
</script>

